import { createFileRoute } from "@tanstack/react-router"
import Addresses from "@/pages/account/addresses"

export const Route = createFileRoute("/$countryCode/account/addresses")({
  head: () => ({
    meta: [
      { title: "Saved addresses | +Bake Cafe" },
      { name: "robots", content: "noindex,nofollow" },
    ],
  }),
  component: Addresses,
})
